import React, { Component } from "react";

import Modal from "react-modal";
import { verify_mobile } from "../utils/Utils";

export default class CardDepoimento extends Component {
  constructor(props) {
    super(props);
    this.state = {
      src: "https://i.ytimg.com/vi/" + this.props.img + "/mqdefault.jpg",
      url: this.props.link
        .replace("https://www.youtube.com/watch?v=", "")
        .replace("https://youtu.be/", ""),
    };
  }

  openModal() {
    this.setState({
      modalIsOpen: true,
    });
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
    });
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = "#f00";
  }

  render() {
    return this.props.paginaVendas ? (
      <div
        className="ui three wide column"
        style={{
          minHeight: !verify_mobile() ? "360px" : null,
          height: "auto",
          minWidth: "262px",
        }}
      >
        <style>{`
                        .playDep:hover {
                            transform: scale(1.2);
                            transition: .3s;
                        }
                    `}</style>
        <a
          style={{ cursor: "pointer" }}
          onClick={() => {
            this.openModal();
          }}
        >
          <img
            style={{
              opacity: "0.8",
              filter: "brightness(71%)",
              width: verify_mobile() ? "90%" : "100%",
              height: "auto",
              border: "none",
              borderRadius: "14px",
            }}
            src={this.state.src}
            alt=""
          />
          <img
            className="playDep"
            style={{
              width: "20%",
              position: "absolute",
              top: "15%",
              left: "50%",
            }}
            src="https://files.voitto.com.br/playDep.png"
          />
        </a>
        <div
          className="ui segment"
          style={{ border: "0", height: "30vh", marginTop: "0" }}
        >
          <p style={{ fontSize: "14px", color: "black", textAlign: "left" }}>
            "{this.props.parafrase}"
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "orangered",
              textAlign: "center",
            }}
          >
            {this.props.nome}
          </p>
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          style={customStyles}
          onRequestClose={() => this.closeModal()}
          onAfterOpen={() => this.afterOpenModal}
        >
          <div>
            <center>
              <iframe
                src={"https://www.youtube.com/embed/" + this.state.url}
                className="modal-youtube"
                allow="accelerometer; autoplay; encrypted-media; 
                        gyroscope; picture-in-picture"
                frameBorder="0"
                allowFullScreen="true"
              ></iframe>
            </center>
          </div>
        </Modal>
      </div>
    ) : this.props.isHome ? (
      <div
        className="ui four wide column"
        style={{
          minHeight: !verify_mobile() ? "340px" : null,
          height: "auto",
          minWidth: "220px",
          borderRadius: 10,
        }}
      >
        <style>{`
                        .playDep:hover {
                            transform: scale(1.2);
                            transition: .3s;
                        }
                    `}</style>

        <a
          style={{ cursor: "pointer" }}
          onClick={() => {
            this.openModal();
          }}
        >
          <img
            style={{
              opacity: "0.8",
              filter: "brightness(71%)",
              width: verify_mobile() ? "90%" : "100%",
              height: "auto",
              border: "none",
              borderRadius: "14px",
            }}
            src={
              "https://img.youtube.com/vi/" +
              this.props.link
                .replace("https://www.youtube.com/watch?v=", "")
                .replace("https://youtu.be/", "") +
              "/mqdefault.jpg"
            }
            alt=""
          />
          <img
            className="playDep"
            style={{
              width: "20%",
              position: "absolute",
              top: "15%",
              left: "42%",
            }}
            src="https://files.voitto.com.br/playDep.png"
          />
        </a>
        <div
          className="ui segment"
          style={{
            border: "0",
            minHeight: "42vh",
            marginTop: "-10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <p
            style={{
              fontSize: "14px",
              color: "black",
              textAlign: "left",
              marginTop: verify_mobile() ? null : "-25px",
            }}
          >
            "{this.props.parafrase}"
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "orangered",
              textAlign: "center",
            }}
          >
            {this.props.nome}
          </p>
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          style={customStyles}
          onRequestClose={() => this.closeModal()}
          onAfterOpen={() => this.afterOpenModal}
        >
          <div>
            <center>
              <iframe
                src={"https://www.youtube.com/embed/" + this.state.url}
                className="modal-youtube"
                allow="accelerometer; autoplay; encrypted-media; 
                            gyroscope; picture-in-picture"
                frameBorder="0"
                allowFullScreen="true"
              ></iframe>
            </center>
          </div>
        </Modal>
      </div>
    ) : (
      <div
        className="ui four wide column"
        style={{
          minHeight: !verify_mobile() ? "340px" : null,
          height: "auto",
          minWidth: "250px",
        }}
      >
        <style>{`
                        .playDep:hover {
                            transform: scale(1.2);
                            transition: .3s;
                        }
                    `}</style>
        <a
          style={{ cursor: "pointer" }}
          onClick={() => {
            this.openModal();
          }}
        >
          <img
            style={{
              opacity: "0.8",
              filter: "brightness(71%)",
              width: verify_mobile() ? "90%" : "100%",
              height: "auto",
              border: "none",
              borderRadius: "14px",
            }}
            src={this.state.src}
            alt=""
          />
          <img
            className="playDep"
            style={{
              width: "20%",
              position: "absolute",
              top: "15%",
              left: "42%",
            }}
            src="https://files.voitto.com.br/playDep.png"
          />
        </a>
        <div
          className="ui segment"
          style={{ border: "0", height: "30vh", marginTop: "0" }}
        >
          <p style={{ fontSize: "14px", color: "black", textAlign: "left" }}>
            "{this.props.parafrase}"
          </p>
          <p
            style={{
              fontSize: "14px",
              color: "orangered",
              textAlign: "center",
              marginTop: verify_mobile() ? "-4%" : null,
            }}
          >
            {this.props.nome}
          </p>
        </div>

        <Modal
          isOpen={this.state.modalIsOpen}
          style={customStyles}
          onRequestClose={() => this.closeModal()}
          onAfterOpen={() => this.afterOpenModal}
        >
          <div>
            <center>
              <iframe
                src={"https://www.youtube.com/embed/" + this.state.url}
                className="modal-youtube"
                allow="accelerometer; autoplay; encrypted-media; 
                        gyroscope; picture-in-picture"
                frameBorder="0"
                allowFullScreen="true"
              ></iframe>
            </center>
          </div>
        </Modal>
      </div>
    );
  }
}

const customStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    zIndex: 99999999,
    background: "rgba(0,0,0,.84)",
    padding: 0,
  },
};
